var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.brandKey !== "mav"
    ? _c(
        "div",
        {
          staticClass: "header-info",
          class: [
            { "footer-override": _vm.mobileBigAndBelow && _vm.state === "NJ" }
          ]
        },
        [
          [
            _vm.isLoggedIn
              ? _c(
                  "span",
                  {
                    staticClass: "header-txt",
                    class: [
                      {
                        "nj-override":
                          !_vm.mobileBigAndBelow && _vm.state === "NJ"
                      }
                    ]
                  },
                  [
                    _vm._v(_vm._s(_vm.$t("MyAccount.LastLogin")) + " "),
                    _c("span", { staticClass: "lastlogin" }, [
                      _vm._v(_vm._s(_vm.lastLogin))
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isLoggedIn
              ? _c(
                  "span",
                  {
                    staticClass: "header-txt",
                    class: [
                      {
                        "nj-override":
                          !_vm.mobileBigAndBelow && _vm.state === "NJ"
                      }
                    ]
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("MyAccount.SessionTime." + _vm.state)) + " "
                    ),
                    _c("span", { staticClass: "clock" }, [
                      _vm._v(_vm._s(_vm.sessionTime))
                    ])
                  ]
                )
              : _vm._e()
          ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a4b383f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a4b383f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/HeaderInfo.vue
// module id = null
// module chunks = 